import { useContext, useEffect, useState } from "react";
import MutationsContext from "./MutationsContext";
import CustomInput from "../genericComponents/CustomInput";
import { Button, Grid2 } from "@mui/material";
import { gql, useMutation } from "@apollo/client";
import mutationCreator from "./mutationCreator";
import Text from "../genericComponents/Text";
import customToast from "../genericComponents/CustomToast";

const MutationSideScreen = ({
    data,    
    setHeader,
    close
}) => {
    const existingData = data.object;
    
    const [postObject, setPostObject] = useState(existingData ? existingData : {});
    const onChange = (property, value) => {
        setPostObject({ ...postObject, [property]: value });
    }        
    const mutationName=data.mutationName;
    const type = data.type;
    
    useEffect(() => {
        setHeader({icon:data.icon,text:`i18n_${mutationName}`});
    }, [setHeader, mutationName])

    const context = useContext(MutationsContext);
    
    const currentMutation = context
        ? context.find((x) => x.typeName === mutationName)
        : null;        
    const MUTATION = (mutationCreator(currentMutation));    
    const [mutateFunction, graphQlObj] = useMutation(gql(MUTATION),{
        refetchQueries:[type+"s"]
      });
    if (!currentMutation) {
        return "Mutation " + mutationName + " not found";
    }
    const save = () => {
        mutateFunction({ variables: postObject })
    }
    if (graphQlObj.data) {
        
        const graphQlResult=graphQlObj.data[currentMutation.typeName];
        if(graphQlResult.isSuccess){
            customToast({type:"success",message:`i18n_${mutationName}_completed`});
            close();
        }else{
            customToast({type:"error",message:graphQlResult.message});
            close();
        }
      }
    return (
        <Grid2 container spacing={1}>
            {currentMutation.definitions.filter(x=>x.propertyName!=="id").map((x, i) => (
                <CustomInput
                    key={i}
                    onChange={e => onChange(x.propertyName, e)}
                    type={x.dataType}
                    value={postObject[x.propertyName]}
                    placeholder={<Text text={`i18n_${type}_${x.propertyName}`}/>}
                    options={x.enumValues}
                    propertyName={x.propertyName}
                />
            ))}
            <Button sx={{color:"white"}} fullWidth variant="contained" onClick={save}>Save</Button>
        </Grid2>
    )
}

export default MutationSideScreen;